// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"55":"teacher","528":"student"}[chunkId] || chunkId) + "." + {"55":"944af35f","81":"3396f3ce","528":"1c671d1d"}[chunkId] + ".js";
};